export const mobilePlatformsEnums = {
  iOS: 'iOS',
  Android: 'Android'
}
